import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueSet, SeatType } from '../../../service/local.service';

@Component({
  selector: 'app-seat-arrangements',
  templateUrl: './seat-arrangements.component.html',
  styleUrls: ['./seat-arrangements.component.scss']
})
export class SeatArrangementsComponent implements OnInit {
  @Input() seatType: SeatType = SeatType.Line; @Input() seatsStatusAndTitle: KeyValueSet[];
  @Input() seatTypeStr = ''; @Input() isDark = true; @Input() isSelectable = false; @Input() isSelectableAdd: boolean = true;
  selectedSeats: string[] = []; @Output() onSeatsSelected = new EventEmitter(); @Output() onSeatSelected = new EventEmitter();
  width = 0;
  constructor() { }

  ngOnInit(): void {
    this.onLoad();
  }

  ngOnChanges() {
    this.onLoad();
  }

  onLoad() {
    if (this.seatTypeStr != '')
      this.seatType = parseInt(this.seatTypeStr);
    this.width = 100 / this.seatsStatusAndTitle.length;
  }

  onAction(index, key) {
    switch (index) {
      case 1: {
        let item = this.seatsStatusAndTitle.find(x => x.key == key);
        if (item) {
          if (this.isSelectable) {
            if (item.isSelected) {
              if (this.selectedSeats.find(x => x == key)) {
                this.selectedSeats = this.selectedSeats.filter(x => x != key);
              } else {
                this.selectedSeats.push(key);
              }
              this.onSeatsSelected.emit(this.selectedSeats);
            }
          } else {
            if (!item.isSelected) {
              this.onSeatSelected.emit(key);
            }
          }
        }
      } break;
    }
  }

}
